<template>
    <AppScaffold grid>
        <Card v-if="data && !loading">
            <h1>{{ $tradFor(data.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <CaddyForm :data="caddyConfig"></CaddyForm>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import CaddyForm from "./caddy-form";
import { assertValidCaddyConfig } from "@/utils/validators";
import { centerToBottomLeft, bottomLeftToCenter } from "./caddy-utils";

export default {
    components: { AppScaffold, Loader, Card, RoundedButton, CaddyForm },
    mixins: [TryLoad],
    data: () => ({
        data: undefined,
        caddyConfig: {
            width: 300,
            height: 150,
            contentX: 0,
            contentY: 10,
            contentWidth: 300,
            contentHeight: 140,
            coverHeight: 10,
            clipDevices: [{ x: 0, y: 0 }],
            ladderWidth: 10,
            ladderHeight: 10,
            topPawl: 0,
            bottomPawl: 0,
            pawlInterval: 10,
            intermediateLadderCount: 0,
            leftAdhesive: false,
            rightAdhesive: false,
            bottomAdhesive: false
        }
    }),
    computed: {
        caddyId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        component() {
            return (
                this.data && {
                    ...this.data,
                    config: centerToBottomLeft(this.data)
                }
            );
        }
    },
    created() {
        this.fetchCaddy();
    },
    methods: {
        async fetchCaddy() {
            this.data = await this.tryLoad(() => componentService.get(this.caddyId));
            this.caddyConfig = {
                ...this.caddyConfig,
                ...centerToBottomLeft(this.data.config)
            };
        },
        async save() {
            assertValidCaddyConfig(this.caddyConfig);
            console.log(bottomLeftToCenter(this.caddyConfig));

            try {
                await componentService.updateConfig(this.caddyId, bottomLeftToCenter(this.caddyConfig));
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// caddy-editor.vue?737aa624